"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckoutBlockedReason = exports.BasketStatus = exports.BasketResponseCode = exports.BasketButtonError = exports.BasketUpdateStatus = exports.BasketCartItemError = exports.DinamicMessagesCalculateTypes = exports.BasketMergeTypes = void 0;
var BasketMergeTypes;
(function (BasketMergeTypes) {
    BasketMergeTypes["ABANDONED"] = "ABANDONED";
    BasketMergeTypes["PERSONAL_SHOPPING_ADVICE"] = "PERSONAL_SHOPPING_ADVICE";
})(BasketMergeTypes || (exports.BasketMergeTypes = BasketMergeTypes = {}));
var DinamicMessagesCalculateTypes;
(function (DinamicMessagesCalculateTypes) {
    DinamicMessagesCalculateTypes["TOTAL"] = "total";
    DinamicMessagesCalculateTypes["SUBTOTAL"] = "subtotal";
})(DinamicMessagesCalculateTypes || (exports.DinamicMessagesCalculateTypes = DinamicMessagesCalculateTypes = {}));
var BasketCartItemError;
(function (BasketCartItemError) {
    BasketCartItemError["ADD_FAILED"] = "ADD_FAILED";
})(BasketCartItemError || (exports.BasketCartItemError = BasketCartItemError = {}));
var BasketUpdateStatus;
(function (BasketUpdateStatus) {
    BasketUpdateStatus["ERROR"] = "ERROR";
    BasketUpdateStatus["OUTOFSTOCK"] = "OUTOFSTOCK";
    BasketUpdateStatus["BUNDLE_OUTOFSTOCK"] = "BUNDLE_OUTOFSTOCK";
    BasketUpdateStatus["SUCCESS"] = "SUCCESS";
    BasketUpdateStatus["PARTIAL_SUCCESS"] = "PARTIAL_SUCCESS";
    BasketUpdateStatus["BULK_OUTOFSTOCK"] = "BULK_OUTOFSTOCK";
})(BasketUpdateStatus || (exports.BasketUpdateStatus = BasketUpdateStatus = {}));
var BasketButtonError;
(function (BasketButtonError) {
    BasketButtonError["SKU"] = "SKU";
    BasketButtonError["SKU_STICKY_BAR"] = "SKU_STICKY_BAR";
    BasketButtonError["SKU_OPEN_SIZE_SELECT"] = "SKU_OPEN_SIZE_SELECT";
    BasketButtonError["STOCK"] = "STOCK";
    BasketButtonError["SIZE_COMBINATION_NOT_EXIST"] = "SIZE_COMBINATION_NOT_EXIST";
})(BasketButtonError || (exports.BasketButtonError = BasketButtonError = {}));
var BasketResponseCode;
(function (BasketResponseCode) {
    BasketResponseCode["HD_EXCLUDED"] = "basket.hd.excluded";
    BasketResponseCode["CC_EXCLUDED"] = "basket.cc.excluded";
    BasketResponseCode["SS_EXCLUDED"] = "product.ss.excluded";
})(BasketResponseCode || (exports.BasketResponseCode = BasketResponseCode = {}));
var BasketStatus;
(function (BasketStatus) {
    BasketStatus[BasketStatus["LOADING"] = 0] = "LOADING";
    BasketStatus[BasketStatus["EMPTY"] = 1] = "EMPTY";
    BasketStatus[BasketStatus["READY"] = 2] = "READY";
    BasketStatus[BasketStatus["ERROR"] = 3] = "ERROR";
})(BasketStatus || (exports.BasketStatus = BasketStatus = {}));
var CheckoutBlockedReason;
(function (CheckoutBlockedReason) {
    CheckoutBlockedReason["HD_EXCLUDED"] = "HD excluded";
    CheckoutBlockedReason["CC_EXCLUDED"] = "C&C excluded";
    CheckoutBlockedReason["SSE_PRODUCT"] = "SSE product";
    CheckoutBlockedReason["SPECIALTY_PRODUCT"] = "Specialty product";
})(CheckoutBlockedReason || (exports.CheckoutBlockedReason = CheckoutBlockedReason = {}));
//# sourceMappingURL=BasketEnums.js.map